import { useState, useEffect, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { AppRoutes } from './router';
import i18n from './i18n';
import ProfileEditModal from './components/feature/ProfileEditModal';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import { TimezoneProvider } from './context/TimezoneContext';

function App() {
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

  useEffect(() => {
    const handleOpenProfileModal = () => {
      setIsProfileModalOpen(true);
    };

    window.addEventListener('openProfileModal', handleOpenProfileModal);

    return () => {
      window.removeEventListener('openProfileModal', handleOpenProfileModal);
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ErrorBoundary>
          <AuthProvider>
            <TimezoneProvider>
              <div className="h-full min-h-0">
                <Suspense
                  fallback={
                    <div className="h-full min-h-[50vh] flex items-center justify-center bg-neutral-50">
                      <div className="flex flex-col items-center gap-4">
                        <div className="w-10 h-10 border-4 border-neutral-200 border-t-cysol-red rounded-full animate-spin" />
                        <p className="text-sm text-neutral-500 font-medium">{i18n.t('common.loading')}</p>
                      </div>
                    </div>
                  }
                >
                  <AppRoutes />
                </Suspense>
              </div>
              <ProfileEditModal
                isOpen={isProfileModalOpen}
                onClose={() => setIsProfileModalOpen(false)}
              />
            </TimezoneProvider>
          </AuthProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
